



































import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import { required } from '@/common/validation/validation';
import { ModelFormModel } from '@/context/model/model/ModelFormModel';
import ObisCodeAutocomplete from '@/common/component/ObisCodeAutocomplete.vue';
import RegisterFormTemplate from '@/context/model/component/RegisterFormTemplate.vue';
import { RegisterFormModel } from '@/context/model/model/RegisterFormModel';

@Component({
  components: {
    ObisCodeAutocomplete,
    DataLoggerAutocomplete,
    FacilityAutocomplete,
    TextInput,
    RegisterFormTemplate
  }
})
export default class ModelFormTemplate extends Vue {
  @VModel({ type: Object }) model!: ModelFormModel;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      model: [required],
      manufacturer: [required]
    };
  }
  addForm(): void {
    this.model.registers?.push(new RegisterFormModel());
  }
  remove(index: number): void {
    this.model.registers?.splice(index, 1);
  }
}
